import styled from "styled-components";


export const OverrideFooterButtonWrapper = styled.div`
box-shadow: 0px -3px 6px #00000029;
background-color: #fff;
position: fixed;
    bottom: 0;
    width: 100%;
     bottom: 44px;
.d-flex{
    justify-content: space-between;
    padding: 18px 0;
    .rightButton{
button{
    background-color:#1B4A83;
    text-transform: capitalize;

}
    }
    .leftButtons{
        display: flex;
        .leftBtnTwo{
            button{
                background-color: rgb(124 9 30);
            }
          
        }
 button{
    margin: 0 18px;
    text-transform: capitalize;

 }
    }
}


`;